import React from 'react';

const preloaderLogo = '/assets/img/nalexus-icon-tp.png';

const Preloader = () => {
  return (
    <div className="preloader">
      <div id="particles-background" className="vertical-centered-box"></div>
      <div id="particles-foreground" className="vertical-centered-box"></div>

      <div className="vertical-centered-box">
        <div className="content">
          <div className="loader-circle"></div>
          <div className="loader-line-mask">
            <div className="loader-line"></div>
          </div>
          <img
            src={preloaderLogo}
            alt="Nalexus Technologies logo"
            className="preloader-logo"
            width={80}
            height={80}
            draggable="false"
          />
        </div>
      </div>
    </div>
  );
};

export default Preloader;



